<div class="mybets-betslip-multi-bet-bet_builder-odds-section">
    <div class="mybets-betslip-info_right-section clearfix">
        <span [ngClass]="{ 'original-odds': betCancelledAndPending() || betCancelledAndRepriced() }">{{ bet().odds | msMyBetsOddsPipe }}</span>
        @if (betCancelledAndPending() || betCancelledAndRepriced()) {
            <span class="repriced-odds">{{
                betCancelledAndPending() ? sitecoreMyBets.myBets.PendingOdds : (bet().ogpRepricingInfo?.odds | msMyBetsOddsPipe)
            }}</span>
        }
    </div>
</div>
@if (isEpcotEnabled) {
    <div class="title">
        @if (myBetsConfig.showBetTypeAsBadge && myBetsUtilService.isBetCardRedesigned()) {
            <ms-sgp-badge size="large" />
        } @else {
            <span class="mybets-betslip-multi-bet_betbuilder-title">{{ sitecoreMyBets.myBets.BuildABet }}</span>
        }
        <span class="mybets-betslip-multi-header_pick-count"> {{ bet().betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.Legs }}</span>
    </div>
} @else {
    <span class="mybets-betslip-multi-bet_betbuilder-title">{{ sitecoreMyBets.myBets.BuildABet }}</span>
    <span class="mybets-betslip-multi-header_pick-count"> - {{ bet().betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.picks }}</span>
}
